import React from 'react';
import { styled } from '@mui/material';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';

type CustomCircularProgressProps = {
  disableBackground?: boolean,
  label?: string,
} & CircularProgressProps;

const Wrapper = styled('div')({
  position: 'relative',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const Back = styled(CircularProgress)(({ theme }) => ({
  position: 'absolute',
  color: theme.palette.grey[400],
}));

const Circle = styled(CircularProgress)({
  strokeLinecap: 'round',
});

const Label = styled('p')(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export default ({
  className,
  style,
  size = 40,
  variant = 'indeterminate',
  disableBackground = false,
  value = 0,
  label,
  ...props
}: CustomCircularProgressProps) => (
  <Wrapper className={className} style={style}>
    {!disableBackground && (
      <Back variant="determinate" value={100} size={size} {...props} />
    )}
    <Circle
      variant={variant}
      value={value}
      size={size}
      {...props}
    />
    {variant === 'determinate'&& label && (
      <Label>{label}</Label>
    )}
  </Wrapper>
);
